module.exports = __webpack_public_path__ + "static/img/austin.ac4a257c.webp";